import Create from './create/CreateCustomSectionTemplate';
import Edit from './edit/EditCustomSectionTemplate';
import Individual from './individual/CustomSectionTemplate';

export default { Create, Individual, Edit };